/** The desktop layout (D65) starts at 1024 px; below it the phone layout is untouched. */
export const DESKTOP_QUERY = '(min-width: 1024px)';

const query = (): MediaQueryList | null =>
  typeof window.matchMedia === 'function' ? window.matchMedia(DESKTOP_QUERY) : null;

export const isDesktop = (): boolean => query()?.matches ?? false;

/** Calls back when the window crosses the breakpoint; returns the unsubscribe. */
export const onBreakpointChange = (cb: (desktop: boolean) => void): (() => void) => {
  const mq = query();
  if (!mq) return () => undefined;
  const handler = (e: MediaQueryListEvent) => cb(e.matches);
  mq.addEventListener('change', handler);
  return () => mq.removeEventListener('change', handler);
};
